module.exports = __webpack_public_path__ + "assets/img/C2.9cd48fe2.jpg";